module.exports = __webpack_public_path__ + "static/media/212-curacao.be619880.svg";